export default {
  methods: {
    getFormat(axis) {
      let result = "AUTO"
      if (this._.keys(axis).includes("decimal")) {
        if (this._.keys(axis).includes("unit")) {
          // 包含unit的为百分比
          switch (axis.decimal) {
            case 2:
              result = "PERCENT"
              break
            case 3:
              result = "PERCENT_ONE"
              break
            case 4:
              result = "PERCENT_TWO"
              break
            case 5:
              result = "PERCENT_THREE"
              break
            case 6:
              result = "PERCENT_FOUR"
              break
          }
        } else {
          switch (axis.decimal) {
            case 0:
              result = "INTEGER"
              break
            case 1:
              result = "ONE_DECIMAL"
              break
            case 2:
              result = "TWO_DECIMAL"
              break
            case 3:
              result = "THREE_DECIMAL"
              break
            case 4:
              result = "FOUR_DECIMAL"
              break
          }
        }
      }
      return result
    }
  }
}
